import { useState } from "react";
import { Col, Row, Container } from "reactstrap";
import { useTranslation } from "react-i18next";

const FlagES = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 750 500" width="24" height="16">
    <rect width="750" height="500" fill="#c60b1e"/>
    <rect width="750" height="250" y="125" fill="#ffc400"/>
  </svg>
);

const FlagUS = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1235 650" width="24" height="16">
    <rect width="1235" height="650" fill="#B22234"/>
    <rect y="50" width="1235" height="50" fill="white"/>
    <rect y="150" width="1235" height="50" fill="white"/>
    <rect y="250" width="1235" height="50" fill="white"/>
    <rect y="350" width="1235" height="50" fill="white"/>
    <rect y="450" width="1235" height="50" fill="white"/>
    <rect y="550" width="1235" height="50" fill="white"/>
    <rect width="494" height="350" fill="#3C3B6E"/>
  </svg>
);

export const HandbookContent = () => {
  const { t, i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language === "en" ? "en" : "es");

  const pdfUrl =
    selectedLanguage === "es"
      ? "/assets/files/guia-participante-cec2026-es.pdf"
      : "/assets/files/guia-participante-cec2026-en.pdf";

  return (
    <div style={{ paddingTop: "60px", paddingBottom: "60px", backgroundColor: "#f8f9fa" }}>
      <Container>
        {/* Título */}
        <Row className="mb-4">
          <Col>
            <h1 className="text-center" style={{ color: "#333333", fontWeight: "bold", marginBottom: "1rem" }}>
              {t("guide_title")}
            </h1>
            <p className="text-center lead" style={{ color: "#666666", fontSize: "1.1rem" }}>
              {t("guide_lead")}
            </p>
          </Col>
        </Row>

        {/* Info cards */}
        <Row className="justify-content-center mb-5">
          <Col md="4" className="mb-4">
            <div style={{
              background: "white", borderRadius: "15px", padding: "2rem",
              boxShadow: "0 5px 20px rgba(0,0,0,0.08)", height: "100%", textAlign: "center",
              transition: "all 0.3s ease",
            }}
              onMouseOver={(e) => { e.currentTarget.style.transform = "translateY(-5px)"; e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.15)"; }}
              onMouseOut={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 5px 20px rgba(0,0,0,0.08)"; }}
            >
              <span style={{ fontSize: "2.5rem" }}>📍</span>
              <h5 style={{ fontWeight: "bold", color: "#333", marginTop: "0.8rem" }}>{t("guide_venue_title")}</h5>
              <p style={{ color: "#555", fontSize: "0.95rem", lineHeight: "1.7" }}>{t("guide_venue_text")}</p>
            </div>
          </Col>
          <Col md="4" className="mb-4">
            <div style={{
              background: "white", borderRadius: "15px", padding: "2rem",
              boxShadow: "0 5px 20px rgba(0,0,0,0.08)", height: "100%", textAlign: "center",
              transition: "all 0.3s ease",
            }}
              onMouseOver={(e) => { e.currentTarget.style.transform = "translateY(-5px)"; e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.15)"; }}
              onMouseOut={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 5px 20px rgba(0,0,0,0.08)"; }}
            >
              <span style={{ fontSize: "2.5rem" }}>🕐</span>
              <h5 style={{ fontWeight: "bold", color: "#333", marginTop: "0.8rem" }}>{t("guide_schedule_title")}</h5>
              <p style={{ color: "#555", fontSize: "0.95rem", lineHeight: "1.7" }}>{t("guide_schedule_text")}</p>
            </div>
          </Col>
          <Col md="4" className="mb-4">
            <div style={{
              background: "white", borderRadius: "15px", padding: "2rem",
              boxShadow: "0 5px 20px rgba(0,0,0,0.08)", height: "100%", textAlign: "center",
              transition: "all 0.3s ease",
            }}
              onMouseOver={(e) => { e.currentTarget.style.transform = "translateY(-5px)"; e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.15)"; }}
              onMouseOut={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 5px 20px rgba(0,0,0,0.08)"; }}
            >
              <span style={{ fontSize: "2.5rem" }}>📧</span>
              <h5 style={{ fontWeight: "bold", color: "#333", marginTop: "0.8rem" }}>{t("guide_contact_title")}</h5>
              <p style={{ color: "#555", fontSize: "0.95rem", lineHeight: "1.7" }}>{t("guide_contact_text")}</p>
            </div>
          </Col>
        </Row>

        {/* Selector de idioma + PDF */}
        <Row className="mb-3">
          <Col className="d-flex justify-content-center gap-3">
            <button
              onClick={() => setSelectedLanguage("es")}
              className="btn btn-lg"
              style={{
                background: selectedLanguage === "es"
                  ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" : "white",
                color: selectedLanguage === "es" ? "white" : "#667eea",
                fontWeight: "700",
                border: selectedLanguage === "es" ? "none" : "2px solid #667eea",
                borderRadius: "10px",
                padding: "0.8rem 2rem",
                boxShadow: selectedLanguage === "es" ? "0 4px 15px rgba(102,126,234,0.4)" : "none",
                transition: "all 0.3s ease",
              }}
            >
              <FlagES /> {t("guide_lang_es")}
            </button>
            <button
              onClick={() => setSelectedLanguage("en")}
              className="btn btn-lg"
              style={{
                background: selectedLanguage === "en"
                  ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" : "white",
                color: selectedLanguage === "en" ? "white" : "#667eea",
                fontWeight: "700",
                border: selectedLanguage === "en" ? "none" : "2px solid #667eea",
                borderRadius: "10px",
                padding: "0.8rem 2rem",
                boxShadow: selectedLanguage === "en" ? "0 4px 15px rgba(102,126,234,0.4)" : "none",
                transition: "all 0.3s ease",
              }}
            >
              <FlagUS /> {t("guide_lang_en")}
            </button>
          </Col>
        </Row>

        {/* Botón de descarga */}
        <Row className="mb-4">
          <Col className="d-flex justify-content-center">
            <a
              href={pdfUrl}
              download
              className="btn"
              style={{
                background: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
                color: "white",
                fontWeight: "700",
                fontSize: "1rem",
                borderRadius: "10px",
                border: "none",
                padding: "0.7rem 2rem",
                boxShadow: "0 4px 15px rgba(17, 153, 142, 0.4)",
                transition: "all 0.3s ease",
              }}
              onMouseOver={(e) => { e.currentTarget.style.transform = "translateY(-2px)"; }}
              onMouseOut={(e) => { e.currentTarget.style.transform = "translateY(0)"; }}
            >
              📄 {t("guide_download")}
            </a>
          </Col>
        </Row>

        {/* Visor PDF */}
        <Row>
          <Col>
            <div style={{
              background: "white", borderRadius: "15px", overflow: "hidden",
              boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
            }}>
              <iframe
                src={pdfUrl}
                width="100%"
                height="700px"
                title="Guía del Participante CEC 2026"
                style={{ border: "none" }}
              >
                {t("guide_no_pdf_support")}{" "}
                <a href={pdfUrl}>{t("guide_download")}</a>.
              </iframe>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};